<!-- message banners -->
<header class="ot-header" role="banner">
  <div class="ot-header__brand">
    <div class="ot-brand ot-brand--is-dark" style="padding-left: 20px;">
      <a href="#" [routerLink]="['home']" class="ot-header__brand">
        <div i18n-alt alt="System Center" title="OpenText" class="ot-header__logo">
          <div class="ot-logo-header"></div>
        </div>
      </a>
      <div class="ot-brand__divider">
      </div>
      <div class="ot-brand__primary">System Center Manager</div>
      <div class="ot-brand__version">{{brandVersion}}</div>
    </div>
  </div>
  <app-message-banner [messages]="messages" (removeMessageEvent)="removeMessageBanner($event)" (messageClickedEvent)="handleMessageBannerLink($event)"></app-message-banner>
  <div class="ot-header__actions">
    <!-- environment switcher -->
    <div class="ot-dropdown">
      <div class="ot-dropdown__trigger">
        <button i18n-title title="Switch environment" id="ot-header__item__switcher_btn" aria-label="trigger" (click)="toggleChangeEnvironmentDialog()" role="button" class="ot-header__item">
        </button>
      </div>
    </div>
    <!-- download -->
    <div class="otsc-download-dropdown ot-dropdown" [ngClass]="{'ot-dropdown--is-active': isActiveDownloadButton}">
      <div class="ot-dropdown__trigger">
        <button i18n-title [title]="downloadStatus && downloadStatus.active.length > 0 ? 'Download in progress...' : 'No download in progress.'" id="ot-header__item__download_btn" aria-label="trigger" (click)="toggleDownloadHeaderBarMessage()" role="button" class="ot-header__item">
        </button>
      </div>
      <div>
        @if (showDownloadHeaderBarMessage) {
          <div id="otsc-download-header-bar" class="ot-message ot-message--is-fixed-top ot-message--is-headerbar ot-message--is-stacked ot-message--is-open ot-message--is-info" [ngClass]="{'ot-message--is-active': showDownloadHeaderBarMessage, 'ot-message--is-open': showDownloadHeaderBarMessageDetail}" (keyup)="onKeyToggleDownloadMenu($event)">
            <div class="ot-message__banner">
              <p class="ot-message__item" i18n>
              {downloadStatus.active.length, plural, =0 {No active downloads} =1 {Downloading 1 item} other {Downloading {{downloadStatus.active.length}} items...}} ({downloadStatus.queue, plural, =0 {no queued items} other {{{downloadStatus.queue}} queued}}, {downloadStatus.errors, plural, =0 {no errors} =1 {1 error} other {{{downloadStatus.errors}} errors}})
            </p>
              @if (downloadStatus.active.length > 0 || downloadStatus.queue > 0) {
                <div tabindex="0" class="ot-message__dropdown-item" (click)="downloadStatus.active.length > 0 && toggleDownloadHeaderBarMessageDetail()" (keyup.enter)="downloadStatus.active.length > 0 && toggleDownloadHeaderBarMessageDetail()">
                </div>
              }
              <button aria-label="Close" class="ot-message__close" id="otsc-download-header-bar-close-btn" (click)="toggleDownloadHeaderBarMessage()">
              </button>
            </div>
            @if (showDownloadHeaderBarMessageDetail) {
              <div class="ot-message__item-group">
                @for (item of downloadStatus.active; track item) {
                  <div class="ot-message__item">
                    <div class="ot-row">
                      <div class="ot-row__column" style="width: 400px; max-width: 400px;">
                        <div class="ot-flex ot-flex--is-v-centered">
                          <img alt="" src="./assets/icons/mime_product.svg" style="width: 48px;">
                          <span class="ot-pl-1 is-size-6" style="overflow: hidden;text-overflow: ellipsis;" [title]="item.fileName">
                            {{item.fileName}}
                          </span>
                        </div>
                      </div>
                      <div class="ot-row__column ot-flex ot-flex--is-centered" style="width: 200px; max-width: 200px;">
                        @if (item.status === 'DOWNLOAD') {
                          <div class="ot-progress ot-progress--is-bar" [ngStyle]="{'width': '12rem'}">
                            <div class="ot-progress__outer">
                              <div class="ot-progress__meter" [ngStyle]="{'width': item.percentage + '%'}">
                              </div>
                            </div>
                            <div class="ot-progress__text">
                              {{item.percentage}}%
                            </div>
                          </div>
                        }
                        @if (item.status !== 'DOWNLOAD') {
                          <div id="ot-toolbar" class="ot-progress ot-progress--is-toolbar">
                            <div id="ot-bouncer-text" class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-has-text">
                              <div class="ot-progress__outer">
                                <div class="ot-progress__meter">
                                </div>
                              </div>
                              @if (item.status === 'INITIATING') {
                                <div class="ot-progress__text" i18n>
                        Initiating...
                      </div>
                              }
                              @if (item.status === 'VALIDATING') {
                                <div class="ot-progress__text" i18n>
                        Validating...
                      </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
    <!-- activity notifications-->
    <div class="otsc-activity-dropdown ot-dropdown" [ngClass]="{'ot-dropdown--is-active': isActiveActivityButton}">
      <div class="ot-dropdown__trigger">
        <button i18n-title [title]="actvitityTitle" id="ot-header__item__activity_btn" aria-label="trigger" (click)="toggleActivityHeaderBarMessage()" role="button" class="ot-header__item">
        </button>
      </div>
      <div>
        @if (showActivityHeaderBarMessage) {
          <div id="otsc-activity-header-bar" class="ot-message ot-message--is-fixed-top ot-message--is-headerbar ot-message--is-stacked ot-message--is-open ot-message--is-info" [ngClass]="{'ot-message--is-active': showActivityHeaderBarMessage, 'ot-message--is-open': showActivityHeaderBarMessageDetail}" (keyup)="onKeyToggleDownloadMenu($event)">
            <div class="ot-message__banner">
              <p class="ot-message__item" i18n>
              {{actvitityTitle}}
            </p>
              @if (activities.size > 0) {
                <div tabindex="0" class="ot-message__dropdown-item" (click)="toggleActivityHeaderBarMessageDetail()" (keyup.enter)="toggleActivityHeaderBarMessageDetail()">
                </div>
              }
              <button aria-label="Close" class="ot-message__close" id="otsc-activity-header-bar-close-btn" (click)="toggleActivityHeaderBarMessage()">
              </button>
            </div>
            @if (showActivityHeaderBarMessageDetail && activities.size > 0) {
              <div class="ot-message__item-group">
                @for (activity of activities | keyvalue; track activity) {
                  <div class="ot-message__item">
                    <div class="ot-flex ot-flex--is-v-centered">
                      <div class="ot-progress-container">
                        <div class="ot-progress ot-progress--is-spinner">
                          <div class="ot-progress__outer">
                            <div class="ot-progress__meter">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="ot-pl-1">
                        <span class="is-size-6">
                          {{activity.value.name}}
                        </span>
                        <p class="ot--has-text-info">
                          <a [routerLink]="activity.value.url" (click)="showActivityHeaderBarMessage = false" class="ot--has-text-info is-size-7">
                            {{activity.value.desc}}
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
    <!-- notifications -->
    <div class="otsc-notification-dropdown ot-dropdown ot-dropdown-notification ot-dropdown--is-right" [title]="notificationCountTitle">
      <span class="ot-header-notification-badge" (click)="openNotificationPanel()" >
        {{notificationCount}}
      </span>
      <button id="ot-header__item__notification_btn" aria-label="trigger" (click)="openNotificationPanel()" role="button"
        class="ot-btn ot-header__item">
      </button>
    </div>
    <!-- help -->
    <div class="otsc-help-dropdown ot-dropdown ot-dropdown--is-right" [ngClass]="{'ot-dropdown--is-active': showHelpMenu}" (keyup)="onKeyToggleHelpMenu($event)" title="Help menu" i18n-title>
      <div>
        <button id="ot-header__item__help_btn" aria-label="trigger" (click)="toggleHelpMenu()" role="button" class="ot-btn ot-header__item">
        </button>
      </div>
      <ul class="ot-dropdown__menu" id="ot-header__item__help">
        <li id="ot-header__item__help_for_this_page" class="ot-dropdown__item" (click)="openForThisPageHelpLink()" (keyup.enter)="openForThisPageHelpLink()" (keydown)="onKey($event)" tabindex="0">
          <span i18n>For This Page</span>
        </li>
        <li id="ot-header__item__help_online_help" class="ot-dropdown__item" (click)="openOnlineHelpLink()" (keyup.enter)="openOnlineHelpLink()" (keydown)="onKey($event)" tabindex="0">
          <span i18n>Online Help</span>
        </li>
        @if (showApiMenu) {
          <li class="ot-dropdown__divider"></li>
        }
        @if (showApiMenu) {
          <li id="ot-header__item__help_api_ref" class="ot-dropdown__item" (click)="openAPIReferenceLink()" (keyup.enter)="openAPIReferenceLink()" (keydown)="onKey($event)" tabindex="0">
            <span i18n >API Reference</span>
          </li>
        }
        <li class="ot-dropdown__divider"></li>
        <li id="ot-header__item__help_about_sc" class="ot-dropdown__item" (click)="toggleShowAboutDialog()" (keyup.enter)="toggleShowAboutDialog()" (keydown)="onKey($event)" tabindex="0">
          <span i18n>About System Center</span>
        </li>
      </ul>
    </div>
    <!-- user menu-->
    <div class="ot-dropdown ot-dropdown--is-right" [ngClass]="{'ot-dropdown--is-active': showUserMenu}" (keyup)="onKeyToggleUserMenu($event)" title="User menu" i18n-title>
      <div class="ot-dropdown__trigger">
        <button id="ot-header__item__usermenu_btn" aria-label="trigger" (click)="toggleUserMenu()" role="button" class="ot-btn ot-header__item ot-pr-0">
          <span>{{getUserInitials()}}</span>
        </button>
      </div>
      <ul class="ot-dropdown__menu" id="ot-header__item__usermenu">
        <li id="ot-header__item__usermenu_profile" class="ot-dropdown__item" (click)="toggleShowProfileDialog()" (keyup.enter)="toggleShowProfileDialog()" tabindex="0" (keydown)="onKey($event)">
          <span i18n>Profile</span>
        </li>
        <li id="ot-header__item__usermenu_sign_out" class="ot-dropdown__item" (click)="logOut()" (keyup.enter)="logOut()" tabindex="0" (keydown)="onKey($event)">
          <span i18n>Sign out</span>
        </li>
      </ul>
    </div>
  </div>
</header>